import { ApiCaller } from 'common/helpers/apiCaller';
import convertToQueryString from 'common/helpers/convertToQueryString';

// ------ Erp ------ //
export const erpService = (data: { page: number; size: number }) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/erp/approvals/${data?.page}/${data?.size}?${convertToQueryString({ ...data, page: undefined, size: undefined })}`
  });
};

// ------ Erp Detail ------ //
export const erpDetailService = (id?: string) => {
  return ApiCaller({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}api/admin/erp/approvals/${id}`
  });
};
